import { getFormData, getQueryString } from 'coreOld/utils';

import { partfinitiClient } from './partfinitiClient';

export const uploadFile = async (data) => {
  const { queryParams, data: file } = data;

  return partfinitiClient.post(
    `/files/index/index?${getQueryString(queryParams)}`,
    getFormData({ files: [file] })
  );
};
